var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13C3 15.6522 4.05357 18.1957 5.92893 20.0711C7.8043 21.9464 10.3478 23 13 23C15.6522 23 18.1957 21.9464 20.0711 20.0711C21.9464 18.1957 23 15.6522 23 13C23 10.3478 21.9464 7.8043 20.0711 5.92893C18.1957 4.05357 15.6522 3 13 3C10.3478 3 7.8043 4.05357 5.92893 5.92893C4.05357 7.8043 3 10.3478 3 13ZM16.3588 9.64126C16.6516 9.93417 16.6516 10.409 16.3587 10.7019L14.0607 12.9995L16.3587 15.2972C16.6516 15.59 16.6516 16.0649 16.3588 16.3578C16.0659 16.6508 15.591 16.6508 15.2981 16.3579L12.9999 14.0601L10.7018 16.3579C10.4089 16.6508 9.93399 16.6508 9.64112 16.3578C9.34825 16.0649 9.34829 15.59 9.64121 15.2972L11.9392 12.9995L9.64121 10.7019C9.34829 10.409 9.34825 9.93417 9.64112 9.64126C9.93399 9.34834 10.4089 9.3483 10.7018 9.64117L12.9999 11.939L15.2981 9.64117C15.591 9.3483 16.0659 9.34834 16.3588 9.64126Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleFilled);
export default __webpack_public_path__ + "static/media/close-circle-filled.2b9a0857fab14be609033792b5c21013.svg";
export { ForwardRef as ReactComponent };